import components from './components/index';
import config from './config';
import views from './views/index';

export { config };
export { components };
export { views };

export default {
  components,
  config,
  views,
};
